import { LoginForm } from "@/shared/auth/ui/LoginForm";

export const LoginPage: React.FC = () => {
  return (
    <div>
      <LoginForm />
    </div>
  );
};
